import React from 'react';

export default function Footer() {
    return (
        <footer className="text-sm text-center text-neutral-500 py-4">
            by Maxim Dikov &copy; 2021 - {new Date().getFullYear()}
        </footer>
    );
}
